import {
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Stack,
    Typography,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import { MODEL_PROPTYPES } from "../../models";
import PropTypes from "prop-types";
import { SoilSaveForm } from "./SoilSaveForm";
import { useSnackbar } from "../../hooks";

SoilSaveModal.propTypes = {
    open: PropTypes.bool.isRequired,
    setIsOpen: PropTypes.func.isRequired,
    soilPolygonsRef: PropTypes.object.isRequired,
    orthoimageCompany: PropTypes.shape(MODEL_PROPTYPES.Company),
    orthoimageContract: PropTypes.shape(MODEL_PROPTYPES.Contract),
    orthoimageSite: PropTypes.shape(MODEL_PROPTYPES.Site),
    orthoimageMission: PropTypes.shape(MODEL_PROPTYPES.Mission),
    refetchMissionGeometries: PropTypes.func,
};

export function SoilSaveModal({
    open,
    setIsOpen,
    soilPolygonsRef,
    orthoimageCompany,
    orthoimageContract,
    orthoimageSite,
    orthoimageMission,
    refetchMissionGeometries,
}) {
    const { openSnackbar } = useSnackbar();
    return (
        <Dialog open={open} fullWidth maxWidth="sm">
            <DialogTitle>
                <Stack
                    direction="row"
                    sx={{ borderBottom: 1, borderColor: "divider" }}
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Typography variant="h5">Save soil</Typography>
                    <IconButton
                        onClick={() => {
                            setIsOpen(false);
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Stack>
            </DialogTitle>
            <DialogContent sx={{ bgcolor: "background.default" }}>
                <SoilSaveForm
                    setIsOpen={setIsOpen}
                    soilPolygonsRef={soilPolygonsRef}
                    openSnackbar={openSnackbar}
                    orthoimageCompany={orthoimageCompany}
                    orthoimageContract={orthoimageContract}
                    orthoimageSite={orthoimageSite}
                    orthoimageMission={orthoimageMission}
                    refetchMissionGeometries={refetchMissionGeometries}
                />
            </DialogContent>
        </Dialog>
    );
}
